import React from 'react';
import Home from "./components/home.js";
import NavBar from "./components/navBar.js";
import Contact from "./components/contact.js";
import About from "./components/about.js";
import Craftsmanship from "./components/craftsmanship.js";
import Testimonial from './components/testimonial.js';
import Footer from './components/footer.js';
import './styles/loader.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from "./ScrollTop.js";
import Soon from "./soon.js";
import ErrorBoundary from "./ErrorBoundary.js";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

function App() {

  return (
    <>
      <div className="App">
        <Router>
          <ErrorBoundary>
            <NavBar />
            <ScrollToTop />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/test" element={<Testimonial />} />
              <Route path="/craftsmanship" element={<Craftsmanship />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/soon" element={<Soon />} />
            </Routes>

            <Footer />
          </ErrorBoundary>
        </Router>
      </div>
    </>
  );
}

export default App;
